module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAAAXNSR0IArs4c6QAAAG5JREFUKFOl0cEJg1AQRdF7i8reRlxJCgjYhQ0IpopA1tYRrED3rkcEPwQx/y8y23dghjdGRAc81Q8/xogYgRvQqv2VS6g6wjfQqPM3PqM9W4C7+krwCqVsAB7qmkM7noD6b5RdVzw8W0GxzOJbNjNeQnV2hlpSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/check.png
// module id = N2uE
// module chunks = 1